import styled from 'styled-components';

const SidebarStyled = styled.div`
  width: 30%;
  background: #fff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
  flex: 0 1 30%;
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
`;

export default SidebarStyled;
